var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "g",
    {
      attrs: {
        id: "Page-1",
        stroke: "none",
        "stroke-width": "1",
        fill: "none",
        "fill-rule": "evenodd"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Desktop-HD",
            transform: "translate(-97.000000, -269.000000)"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "icons/battery-cel-level-1",
                transform: "translate(97.000000, 269.000000)"
              }
            },
            [
              _c("rect", {
                staticStyle: { "mix-blend-mode": "color-burn" },
                attrs: {
                  id: "Rectangle",
                  "fill-opacity": "0.01",
                  fill: "#E3E3E3",
                  x: "0",
                  y: "0",
                  width: "24",
                  height: "24"
                }
              }),
              _vm._v(" "),
              _c(
                "g",
                {
                  attrs: {
                    id: "Group-4",
                    "stroke-width": "1",
                    transform: "translate(6.000000, 2.000000)"
                  }
                },
                [
                  _c("rect", {
                    attrs: {
                      id: "Rectangle",
                      fill: "#1F2848",
                      x: "0",
                      y: "3",
                      width: "12",
                      height: "17"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      id: "Rectangle",
                      fill: "#FFFFFF",
                      x: "2",
                      y: "5",
                      width: "8",
                      height: "13"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      id: "Rectangle",
                      fill: "#1F2848",
                      x: "4",
                      y: "0",
                      width: "4",
                      height: "2"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "g",
                {
                  attrs: {
                    id: "Group-Copy",
                    "stroke-width": "1",
                    transform: "translate(10.000000, 9.000000)"
                  }
                },
                [
                  _c("rect", {
                    attrs: {
                      id: "Rectangle",
                      fill: "#D8D8D8",
                      x: "0",
                      y: "0",
                      width: "4",
                      height: "1.28571429"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      id: "Rectangle-Copy",
                      fill: "#D8D8D8",
                      x: "0",
                      y: "2.57142857",
                      width: "4",
                      height: "1.28571429"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      id: "Rectangle-Copy-3",
                      fill: "#D8D8D8",
                      x: "0",
                      y: "5.14285714",
                      width: "4",
                      height: "1.28571429"
                    }
                  }),
                  _vm._v(" "),
                  _c("rect", {
                    attrs: {
                      id: "Rectangle-Copy-2",
                      fill: "#F50E02",
                      x: "0",
                      y: "7.71428571",
                      width: "4",
                      height: "1.28571429"
                    }
                  })
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }